import React, { useEffect, useState } from 'react'
import { Dialog, DialogContent, DialogActions, Button, Typography, makeStyles } from '@material-ui/core'
import HolidayForm from './HolidayForm'
import { HolidayRequest, useSettingHoliday } from '../../../services/um/useSettingHoliday'
import useLoading from '../../../control/loading/useLoading'
import useTranslate from '../../../i18n/useTranslate'
import DuplicateHolidayDialog from './DuplicateHolidayDialog'

type Props = {
    open: boolean
    initialValue?: HolidayRequest
    onCancel: () => void
    onSuccess: () => void
}

const HolidayEditDialog: React.FC<Props> = ({ open, onCancel, initialValue, onSuccess }) => {
    const classes = useStyles()
    const translate = useTranslate()
    const loadingHook = useLoading()
    const { upsertHolidaySetting } = useSettingHoliday()

    const [value, setValue] = useState<HolidayRequest>({})
    const [duplicateOpen, setDuplicateOpen] = useState(false)

    useEffect(() => {
        if (initialValue) setValue(initialValue)
    }, [initialValue])

    const handleSubmit = async (newValue: HolidayRequest) => {
        loadingHook.loadingOpen()
        try {
            const res = await upsertHolidaySetting(newValue)
            if (res.message === 'DUPLICATE DATE') {
                setDuplicateOpen(true)
                return
            }
            onSuccess()
        } finally {
            loadingHook.loadingClose()
        }
    }

    return (
        <>
            <Dialog open={open} onClose={onCancel} fullWidth maxWidth="sm">
                <Typography variant="h6" className={classes.header}>
                    {translate.get('UM.SETTING_HOLIDAY.EDIT_HOLIDAY')}
                </Typography>

                <DialogContent className={classes.content}>
                    <HolidayForm value={value} onChange={(e) => handleSubmit(e)} onCancel={onCancel} />
                </DialogContent>
            </Dialog>

            <DuplicateHolidayDialog open={duplicateOpen} onClose={() => setDuplicateOpen(false)} />
        </>
    )
}

const useStyles = makeStyles((theme) => ({
    header: { background: '#DB5F8E', color: '#fff', padding: theme.spacing(2), fontWeight: 700 },
    content: { display: 'flex', justifyContent: 'center', padding: 20 },
}))

export default HolidayEditDialog
